import { Switch } from "antd";
import React, { Component } from "react";
import QrReader from "react-qr-reader";

export default class QrReaderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      access: false,
    };
  }

  componentWillUnmount() {
    this.setState({ show: false });
  }

  render() {
    const { handleError, Check } = this.props;


      return (
        <React.Fragment>
          {this.state.show&&<QrReader
            legacyMode={this.state.access}
            className="Qr-reader"
            delay={500}
            onError={handleError}
            onScan={(data) => {
              if (data) {
                // var check = new_system.includes(data);
                // console.log(JSON.parse((data)));
                Check(JSON.parse((data)));
              } else {
                // console.log("your result isn't null", data);
              }
            }}
            style={{ width: "100%" }}
          />}
          <Switch className="qr-switch" onChange={(e)=>this.setState({show:e})} checkedChildren="روشن" unCheckedChildren="خاموش"  />
        </React.Fragment>
      );
    
  }
}
